/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    admin: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UserData
     */
    usedStorage: number;
    /**
     * 
     * @type {number}
     * @memberof UserData
     */
    availableStorage: number;
}

/**
 * Check if a given object implements the UserData interface.
 */
export function instanceOfUserData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uuid" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "lastname" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "admin" in value;
    isInstance = isInstance && "usedStorage" in value;
    isInstance = isInstance && "availableStorage" in value;

    return isInstance;
}

export function UserDataFromJSON(json: any): UserData {
    return UserDataFromJSONTyped(json, false);
}

export function UserDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'name': json['name'],
        'lastname': json['lastname'],
        'email': json['email'],
        'admin': json['admin'],
        'usedStorage': json['usedStorage'],
        'availableStorage': json['availableStorage'],
    };
}

export function UserDataToJSON(value?: UserData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
        'name': value.name,
        'lastname': value.lastname,
        'email': value.email,
        'admin': value.admin,
        'usedStorage': value.usedStorage,
        'availableStorage': value.availableStorage,
    };
}

